var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NewTask',{attrs:{"taskType":"bank_statement","docList":['Bank Statement'],"textInput":_vm.textInput,"beforeCreate":_vm.processTextInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }